import { required } from 'react-admin';
import { DefaultToolbar } from '@/components/toolbars';
import { COMBINED_REASONS_KEY } from './constants';
import { TextInputStyled } from './styled';
import { AdverseEditNoteProps } from '../types';
import useController from './useController';

const FormContent = (props: AdverseEditNoteProps) => {
  const { handleClose, handleSave } = useController(props);

  return (
    <>
      <TextInputStyled source={COMBINED_REASONS_KEY} label="Add a note" multiline rows={4} validate={required()} />

      <DefaultToolbar onClose={handleClose} onSave={handleSave} />
    </>
  );
};

export default FormContent;
